import React from 'react'

import { useSkeletonLoadingContacts } from 'src/features/SkeletonLoadingContacts/useSkeletonLoadingContacts'
import { SkeletonLoadingContactsProps } from 'src/features/SkeletonLoadingContacts/types'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'src/components/shadcn/table'
import { Skeleton } from 'src/components/shadcn/skeleton'

export const SkeletonLoadingContacts = ({
  tableCount,
}: SkeletonLoadingContactsProps): JSX.Element => {
  const { tables, headers, fields } = useSkeletonLoadingContacts(tableCount)

  return (
    <>
      {tables.map(tableItem => (
        <div key={tableItem} className="mb-6">
          <Skeleton className="h-4 ml-4 w-[80px] rounded animate-pulse" />
          <Table>
            <TableHeader>
              <TableRow>
                {headers.map(headersItem => (
                  <TableHead key={headersItem}>
                    <Skeleton className="h-4 w-full rounded animate-pulse" />
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {fields.map(rowItem => (
                <TableRow key={rowItem}>
                  {headers.map(cellItem => (
                    <TableCell key={cellItem} className="p-2">
                      <Skeleton className="h-6 ml-2 w-full rounded animate-pulse" />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ))}
    </>
  )
}
